export const routes = {
  login: '/',
  loginCallback: '/login-callback',
  dashboard: '/dashboard',
  creditApplications: '/credit-applications',
  programs: '/programs',
  users: '/users',
  securityEvents: '/security-events',
  manualReview: '/manual-review',
  creditEngine: '/credit-engine',
  profile: '/profile',
  settings: '/settings',
  legalLinks: '/legal-links',
  reports: '/reports',
  lookerStudio: '/looker-studio',
  successful: '/successful',
};
